import {
  Heart,
  ArrowRight,
  BarChart3,
  Bell,
  BookOpen,
  Briefcase,
  Building2,
  Calendar,
  CircleHelp,
  ClipboardList,
  Compass,
  Contact,
  FileCheck,
  Files,
  FileText,
  Folder,
  FolderLock,
  GraduationCap,
  Home,
  Image,
  Images,
  KeyRound,
  Landmark,
  LayoutDashboard,
  LifeBuoy,
  MapPin,
  Megaphone,
  Newspaper,
  School,
  ScrollText,
  Search,
  Settings,
  Shield,
  Sparkles,
  Train,
  Trophy,
  Upload,
  UserCircle,
  Users,
  Eye,
  Download,
  Trash2,
  Edit,
  Share2,
  CheckCircle,
  type LucideIcon,
} from 'lucide-react';

/** Maps icon names from the CMS/API to Lucide components — not business data. */
const ICON_MAP: Record<string, LucideIcon> = {
  ArrowRight,
  BarChart3,
  Bell,
  BookOpen,
  Briefcase,
  Building2,
  Calendar,
  CircleHelp,
  ClipboardList,
  Compass,
  Contact,
  FileCheck,
  Files,
  FileText,
  Folder,
  FolderLock,
  GraduationCap,
  Heart,
  Home,
  IdCard: Contact,
  Image,
  Images,
  KeyRound,
  Landmark,
  LayoutDashboard,
  LifeBuoy,
  MapPin,
  Megaphone,
  Newspaper,
  School,
  ScrollText,
  Search,
  Settings,
  Shield,
  Sparkles,
  Train,
  Trophy,
  Upload,
  UserCircle,
  Users,
  Eye,
  Download,
  Trash: Trash2,
  Edit,
  Share: Share2,
  Check: CheckCircle,
  Document: FileText,
  File: FileText,
  Certificate: ScrollText,
  AdmitCard: ClipboardList,
  Identity: Contact,
  Photo: Image,
};

export function resolveIcon(name?: string | null, fallback: LucideIcon = FileText): LucideIcon {
  if (!name) return fallback;
  const key = String(name).trim();
  return ICON_MAP[key] ?? ICON_MAP[key.toLowerCase()] ?? fallback;
}
